import { render, staticRenderFns } from "./RFIDTest.vue?vue&type=template&id=60e970d1"
import script from "./RFIDTest.vue?vue&type=script&lang=js"
export * from "./RFIDTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports